import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DoneIcon from "@material-ui/icons/Done";
import axios from "../AxiosClient";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { currentUserHasRole, Role } from "../utils/RoleUtils";
import {
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormGroup,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  withStyles,
  withTheme,
} from "@material-ui/core";
import ClickAndDoubleClick from "./taxonomy/ClickAndDoubleClick";

const styles = (theme) => ({
  container: {
    zIndex: 135001,
    backgroundColor: "red",
  },
  formControl: {
    minWidth: 200,
    width: "100%",
  },
  editButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  // dialogPaper: {
  //   position: "absolute",
  //   top: this.state.pos.top ,
  //   right: this.state.pos.left,
  // }
  paperStyle: {
    backgroundColor: "red",
    position: "absolute",
    top: 0,
    left: 0,
  },
});
const checkBoxSVG =
  "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z";
const checkedBoxSVG =
  "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z";
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class DocumentType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentType: [-3],
      documentTypes: this.props.doctypes || [],
      instance: new Date().getTime().toString(),
      withdrawnFilter: "",
      newDocTypeName: "",
      editable: false,
      openMenu: false,
      doctypeDialogOpen: false,
      anchorEl: null,
      expanded: ["-3"],
      selected: [],
      pos: { left: 0, top: 0 },
    };
  }
  componentDidMount() {
    this.setState({
      documentType:
        this.props.documentType &&
        Array.isArray(this.props.documentType) &&
        this.props.documentType.length > 0
          ? this.props.documentType
          : [-3],
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.doctypes !== this.props.doctypes && this.props.doctypes) {
      this.setState({ documentTypes: this.props.doctypes });
    }
    if (
      prevProps.documentType !== this.props.documentType &&
      this.props.documentType
    ) {
      this.setState({
        documentType:
          this.props.documentType &&
          Array.isArray(this.props.documentType) &&
          this.props.documentType.length > 0
            ? this.props.documentType
            : [-3],
      });
    }
    if (this.state !== prevState) {
      if (this.props.stateUpdated) this.props.stateUpdated(this.state);
    }
    const ev = {
      target: { name: "documentTypes", value: this.state.documentType },
    };
    // const ev = {
    //   target: { name: "documentTypes",
    //   value: (this.props.documentType &&
    //           Array.isArray(this.props.documentType) &&
    //           (this.props.documentType.length > 1 || this.props.documentType[0] !== -3)) ?
    //           this.props.documentType : [] },
    // };
    !areObjectsEqual(prevState.documentType, this.state.documentType) &&
      this.props.multiSelect === true &&
      this.props.docTypeSelected &&
      this.props.docTypeSelected(ev);
  }
  renderNode = (node) => {
    const { classes } = this.props;
    let childNodes = node.children ? node.children : [];
    return (
      <TreeItem
        nodeId={node.documentTypeID === -1 ? "none" : "" + node.documentTypeID}
        key={node.documentTypeID === -1 ? "none" : "" + node.documentTypeID}
        aria-selected={
          this.getSelectedNodePos(node) > -1 ||
          this.getSelectedNodePos({ documentTypeID: -3 }) > -1
        }
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            this.onClickNode(node, e);
          }
        }}
        label={
          <ClickAndDoubleClick
            onClick={(node, e) => this.onClickNode(node, e)}
            onDoubleClick={(node, e) => this.onDoubleClickNode(node, e)}
            node={node}
            children={
              <>
                <div className={classes.labelRoot}>
                  <svg
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path
                      fill={
                        this.getSelectedNodePos(node) > -1 ||
                        this.getSelectedNodePos({ documentTypeID: -3 }) > -1
                          ? `${this.props.theme.palette.secondary.light}`
                          : `${this.props.theme.palette.primary.light}`
                      }
                      d={
                        this.getSelectedNodePos(node) > -1 ||
                        this.getSelectedNodePos({ documentTypeID: -3 }) > -1
                          ? checkedBoxSVG
                          : checkBoxSVG
                      }
                    />
                  </svg>
                </div>
                <div className={classes.labelRoot}>
                  <Typography className={classes.labelText}>
                    {node.documentTypeID === -3
                      ? this.props.t(node.name)
                      : node.name}
                  </Typography>
                </div>
              </>
            }
          />
        }
      >
        {childNodes.map((child) => {
          return this.renderNode(child, node);
        })}
      </TreeItem>
    );
  };
  docTypesAsTree = () => {
    let root = this.state.documentTypes.filter(
      (el) => el.documentTypeID === -3
    )[0];
    root.children = this.state.documentTypes.filter(
      (el) => el.documentTypeID !== -3 && el.withdrawnFilter === 0
    );
    return root;
  };
  handleToggle = (event, nodeIds) => {
    this.setState({ expanded: nodeIds });
  };
  onClickNode = (node, event) => {
    let pos = this.getSelectedNodePos(node);
    if (pos > -1) {
      let newTypes = this.state.documentType.map((x) => x);
      if (newTypes.length > 1) {
        newTypes.splice(pos, 1);
        this.setState({ documentType: [...newTypes] });
      }
    } else {
      let allPos = this.getSelectedNodePos({ documentTypeID: -3 });
      if (allPos > -1) {
        //remove the "ALL" and the current selection and add all others
        let newTypes = [
          ...this.state.documentTypes.filter(
            (el) =>
              el.documentTypeID !== -3 &&
              el.documentTypeID !== node.documentTypeID
          ),
        ];
        this.setState({
          documentType: [...newTypes.map((el) => el.documentTypeID)],
        });
      } else {
        if (
          node.documentTypeID === -3 ||
          this.state.documentType.length === this.state.documentTypes.length - 2
        ) {
          this.setState({ documentType: [-3] });
        } else {
          let newTypes = this.state.documentType.map((x) => x);
          newTypes.push(node.documentTypeID);
          this.setState({ documentType: [...newTypes] });
        }
      }
    }
  };
  onDoubleClickNode = (node, event) => {
    this.setState({ documentType: [...[node.documentTypeID]] });
  };
  getSelectedNodePos = (node) => {
    let pos = this.state.documentType
      ? this.state.documentType.indexOf(node.documentTypeID)
      : -1;
    return pos;
  };
  openDocTypeDialog = (e) => {
    this.setState({
      doctypeDialogOpen: true,
    });
  };
  getOffset = (el) => {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
    };
  };
  handleDoctypeDialogClose = () => {
    this.setState({ doctypeDialogOpen: false });
  };
  getDocumentTypeName = (docTypeId) => {
    let pos = this.state.documentTypes
      .map((el) => el.documentTypeID)
      .indexOf(docTypeId);
    if (pos > -1) {
      if (this.state.documentTypes[pos].documentTypeID === -3) {
        return this.props.t(this.state.documentTypes[pos].name);
      }
      return this.state.documentTypes[pos].name;
    }
  };

  render() {
    const { classes, t } = this.props;

    return (
      <>
        {this.state.editable === true && (
          <Dialog
            open={true}
            onClose={this.handleDoctypeDialogClose}
            style={{ zIndex: 10002 }}
          >
            <DialogTitle>
              <Trans i18nKey="document_type" />
            </DialogTitle>
            <DialogContent>
              <FormGroup row={true}>
                <FormControl>
                  <Input
                    type="text"
                    fullWidth
                    value={this.state.newDocTypeName}
                    onChange={this.handleAddChange}
                  />
                </FormControl>
                <FormControl>
                  <Tooltip
                    title={t("add_new_document_type")}
                    aria-label={t("add_new_document_type")}
                  >
                    <IconButton color="primary" onClick={this.addNewDocType}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                </FormControl>
              </FormGroup>
              {this.state.documentTypes
                .filter((el) => el.documentTypeID !== -3)
                .sort((a, b) => a.documentTypeID - b.documentTypeID)
                .map((element, index) => {
                  return (
                    <FormGroup row={true} key={element.documentTypeID}>
                      <FormControl>
                        <Input
                          type="text"
                          fullWidth
                          onBlur={this.updateDocType.bind(
                            this,
                            element.documentTypeID,
                            index
                          )}
                          defaultValue={element.name}
                        />
                      </FormControl>
                      <FormControl>
                        <Tooltip
                          title={t("document_type_active")}
                          aria-label={t("document_type_active")}
                        >
                          <Checkbox
                            checked={!element.withdrawnFilter}
                            onChange={this.updateWithdrawnFilter.bind(
                              this,
                              element.documentTypeID
                            )}
                          />
                        </Tooltip>
                      </FormControl>
                    </FormGroup>
                  );
                })}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.openEditableMenu} color="primary">
                <Trans i18nKey="global_close" />
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.editable === false && this.props.multiSelect === true ? (
          <>
            <TextField
              disabled={this.props.disabled}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  e.stopPropagation();
                  this.openDocTypeDialog();
                }
              }}
              id="documentType"
              label={
                this.props.inputLabel
                  ? this.props.inputLabel
                  : t("document_type")
              }
              value={
                this.state.documentType
                  ? this.state.documentType.length > 1
                    ? "Multiple Selections"
                    : this.getDocumentTypeName(this.state.documentType[0])
                  : "All Document Types"
              }
              onClick={this.openDocTypeDialog}
              margin="none"
              InputProps={{
                readOnly: true,
              }}
            />
            <Dialog
              open={this.state.doctypeDialogOpen}
              onClose={this.handleDoctypeDialogClose}
              style={{ zIndex: 10002 }}
            >
              <Paper elevation={10}>
                <DialogTitle>
                  <Trans i18nKey="document_type" />
                  {this.canUserEdit() && (
                    <Tooltip
                      title={t("edit_document_types")}
                      aria-label={t("edit_document_types")}
                    >
                      <IconButton
                        onClick={this.openEditableMenu}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </DialogTitle>
                <DialogContent className={classes.taxonomyDialog}>
                  <TreeView
                    onNodeSelect={this.treeNodeSelect}
                    selected={this.state.selected}
                    expanded={this.state.expanded}
                    onNodeToggle={this.handleToggle}
                    // selected={this.state.documentType}
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    defaultEndIcon={<div style={{ width: 24 }} />}
                    children={this.renderNode(this.docTypesAsTree())}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.handleDoctypeDialogClose}
                    color="primary"
                  >
                    <Trans i18nKey="global_close" />
                  </Button>
                </DialogActions>
              </Paper>
            </Dialog>
          </>
        ) : (
          <>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="documentType">
                <Trans i18nKey="document_type" />
              </InputLabel>
              <Select
                aria-label="Template document type"
                disabled={this.props.disabled}
                value={
                  this.props.documentType && this.props.documentType.length > 0
                    ? this.props.documentType
                    : this.props.search
                      ? [-3]
                      : [-1]
                }
                renderValue={(selected) => {
                  let type = typeof selected;
                  if (type === "object") {
                    let filtered = this.state.documentTypes
                      .filter((el) => selected.indexOf(el.documentTypeID) > -1)
                      .map((el) => el.name);
                    return filtered.length > 0 ? filtered.toString() : "";
                  } else {
                    return selected;
                  }
                }}
                onChange={this.props.docTypeSelected}
                open={this.state.openMenu}
                onClose={this.closeSelect}
                onOpen={this.openEditMenu}
                inputProps={{
                  name: this.props.multiSelect
                    ? "documentTypes"
                    : "documentType",
                  id: "documentTypes",
                }}
              >
                {this.canUserEdit() && (
                  <div className={classes.editButton}>
                    <Tooltip
                      title={t("edit_document_types")}
                      aria-label={t("edit_document_types")}
                    >
                      <IconButton
                        onClick={this.openEditableMenu}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}

                {this.state.documentTypes
                  .sort((a, b) => a.documentTypeID - b.documentTypeID)
                  .map((element, index) => {
                    if (element.documentTypeID === -3 && !this.props.search) {
                      return null;
                    }
                    return (
                      this.isDocumentTypeWithdrawn(
                        element.withdrawnFilter,
                        element.documentTypeID
                      ) && (
                        <MenuItem
                          key={element.documentTypeID}
                          value={element.documentTypeID}
                          aria-label={`${element.name}`}
                        >
                          <Input
                            fullWidth
                            inputProps={{ style: { cursor: "pointer" } }}
                            disableUnderline
                            onChange={this.handleInputChange(index)}
                            value={this.state.documentTypes[index].name}
                          />
                        </MenuItem>
                      )
                    );
                  })}
              </Select>
            </FormControl>
          </>
        )}
      </>
    );
  }

  treeNodeSelect = (event, nodeIds) => {
    this.setState({ selected: nodeIds });
  };

  isDocumentTypeWithdrawn = (withdrawnFilter, documentTypeID) => {
    if (
      documentTypeID == "-3" ||
      (withdrawnFilter === 0 && !this.state.editable)
    ) {
      return true;
    } else if (this.state.editable) {
      return true;
    } else {
      return false;
    }
  };

  closeSelect = () => {
    if (!this.state.editable) {
      this.setState({ openMenu: false });
    }
  };

  handleAddChange = (event) => {
    this.setState({ newDocTypeName: event.target.value });
  };

  handleInputChange = (index) => (event) => {
    let doctypes = [...this.state.documentTypes];
    doctypes[index].name = event.target.value;
    this.setState({ documentTypes: doctypes });
  };

  openEditMenu = () => {
    this.setState({ openMenu: true });
  };

  docTypeSelected = (event) => {
    this.setState({ documentType: event.target.value });
  };

  closeEditMenu = () => {
    this.setState({ openMenu: false });
  };

  updateDocType = (documentTypeID, index, event) => {
    this.state.documentTypes
      .filter((el) => el.documentTypeID === documentTypeID)
      .map((element) => {
        element.name !== event.target.value &&
          axios
            .patch(`/documenttype/${element.documentTypeID}`, {
              name: event.target.value,
              withdrawnFilter: element.withdrawnFilter ? 1 : 0,
            })
            .then(() => {
              this.getDocTypes();
            });
      });
  };

  updateDocTypes = () => {
    this.state.documentTypes.map((element, index) => {
      (element.name !== this.props.doctypes[index].name ||
        element.withdrawnFilter !==
          this.props.doctypes[index].withdrawnFilter) &&
        axios
          .patch(`/documenttype/${element.documentTypeID}`, {
            name: element.name,
            withdrawnFilter: element.withdrawnFilter ? 1 : 0,
          })
          .then(() => {
            this.getDocTypes();
            // this.state.editable = false
          });
    });
  };

  updateWithdrawnFilter = (documentTypeID, event) => {
    this.state.documentTypes
      .filter((el) => el.documentTypeID === documentTypeID)
      .map((element) => {
        axios
          .patch(`/documenttype/${documentTypeID}`, {
            name: element.name,
            withdrawnFilter: event.target.checked ? 0 : 1,
          })
          .then(() => {
            this.getDocTypes();
          });
      });
  };

  addNewDocType = () => {
    axios
      .post("/documenttype/", {
        name: this.state.newDocTypeName,
        withdrawnFilter: 0,
      })
      .then(() => {
        this.setState({ newDocTypeName: "" });
        this.getDocTypes();
      });
  };

  openEditableMenu = () => {
    this.setState((prevState) => ({ editable: !prevState.editable }));
  };

  canUserEdit = () => {
    return currentUserHasRole(Role.MODERATOR);
  };

  getDocTypes = () => {
    axios.get("/documenttype/", { withCredentials:true }).then((res) => {
      this.setState({ documentTypes: res.data });
    });
  };
}

export default withTheme(withStyles(styles)(withTranslation()(DocumentType)));
